import React, { useEffect, useState } from "react";
import { Accordion, AccordionSummary } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { AssetAccordionDetails } from "../../../ui-components/pageLayout/TableSettingsComponents";
import { FieldArray } from "formik";
import { EntitySelectionTable } from "../../../ui-components/pageLayout/EntitySelectionTable";
import { fromJson } from "../../../../../models/modelHelpers";
import { SectionWrapper } from "../../../../UI/SectionWrapper/SectionWrapper";
import { useSelector } from "react-redux";
import { CMSTag } from "../../../../../models/CMS/cmsTag";
import { getTagsSelector } from "../../../store/reducers/cmsReducer";

const GenresAccordion: React.FC = () => {
  const tags = useSelector(getTagsSelector);
  const [filteredGenres, setFilteredGenres] = useState<CMSTag[]>();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const genreTags = tags.filter((tag) => tag.getType() === "genre");
    setFilteredGenres(genreTags);
  }, [tags]);

  const genresSearchFunc = (query: string) => {
    const genreTags = tags.filter((tag) => tag.getType() === "genre");
    setFilteredGenres(
      genreTags.filter((tag) =>
        tag.getDisplayName().toLowerCase().includes(query.toLowerCase())
      )
    );
  };

  return (
    <SectionWrapper>
      <Accordion onChange={(event, expanded) => setIsOpen(expanded)}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          className="accordion-summary-gray"
        >
          Genres
        </AccordionSummary>
        <AssetAccordionDetails>
          <FieldArray
            name="tags"
            render={({ push, remove, form }) => {
              //quickfix for rendering alot of rows in EntitySelectionTable with images that slows down rerendering
              if (!isOpen) return;

              // Filter current tags to only show genre-type tags
              const currentGenreTags = (form.values.tags || [])
                .map((entity) => fromJson(CMSTag, entity) as CMSTag)
                .filter((tag) => tag.getType() === "genre");

              return (
                <EntitySelectionTable
                  label="genres"
                  values={filteredGenres}
                  selectedValues={currentGenreTags}
                  searchFunction={genresSearchFunc}
                  push={(entity) => {
                    const tag = entity as CMSTag;
                    // Only add if it's a genre tag and not already in tags array
                    const exists = form.values.tags?.some(
                      (t) => t.tagId === tag.tagId
                    );
                    if (!exists && tag.getType() === "genre") {
                      push(tag.serialize());
                    }
                  }}
                  remove={(index) => {
                    // Find the actual index in the tags array
                    const genreTag = currentGenreTags[index];
                    const actualIndex = form.values.tags?.findIndex(
                      (t) => t.tagId === genreTag.tagId
                    );
                    if (actualIndex !== -1) {
                      remove(actualIndex);
                    }
                  }}
                />
              );
            }}
          />
        </AssetAccordionDetails>
      </Accordion>
    </SectionWrapper>
  );
};

export default GenresAccordion;
